/* eslint-disable import/no-anonymous-default-export */
import type { AxiosResponse } from "axios";
import apiClient from "@utilities/apiClient";
import EndpointsConst from "@consts/EndpointsConst";

interface HelpRequestPayload {
  firstName: string;
  lastName: string;
  email: string;
  message: string;
  /** 0 General Work, 1 Low, 2 Moderate, 3 Critical - see TicketConst */
  priorityLevel: number;
}

interface ContactFormPayload {
  subject: string;
  name: string;
  email: string;
  message: string;
  recaptchaToken: string;
}

class MailService {
  /**
   * [POST]
   * Submits customer help request, emailing it and filing it as a polis tech ticket
   * @param payload - The requester's name, email, message, and priority level
   */
  submitHelpRequest({
    firstName,
    lastName,
    email,
    message,
    priorityLevel,
  }: HelpRequestPayload): Promise<AxiosResponse> {
    return apiClient.post(EndpointsConst.API.MAIL.SUBMIT_HELP_REQUEST, {
      firstName,
      lastName,
      email,
      message,
      priorityLevel,
    });
  }

  /**
   * [POST]
   * Submits the public contact form
   * @param payload - The form subject, sender details, message, and reCAPTCHA token
   */
  submitContactForm({
    subject,
    name,
    email,
    message,
    recaptchaToken,
  }: ContactFormPayload): Promise<AxiosResponse> {
    return apiClient.post(EndpointsConst.API.MAIL.SUBMIT_CONTACT_FORM, {
      subject,
      name,
      email,
      message,
      recaptchaToken,
    });
  }
}

export default new MailService();
